"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentHistoryEntryShort = /** @class */ (function () {
    function PaymentHistoryEntryShort(isInput, delta, asset, assetId, entryIndex, timestamp, transactionId, transactionData, blockHeight) {
        this.isInput = isInput;
        this.delta = delta;
        this.asset = asset;
        this.assetId = assetId;
        this.entryIndex = entryIndex;
        this.timestamp = timestamp;
        this.transactionId = transactionId;
        this.transactionData = transactionData;
        this.blockHeight = blockHeight;
    }
    PaymentHistoryEntryShort.from = function (responseEntry) {
        return new PaymentHistoryEntryShort(responseEntry.is_input === 1, responseEntry.delta, responseEntry.asset, responseEntry.asset_id, responseEntry.entry_index, new Date(responseEntry.timestamp), responseEntry.tx_rid.toUpperCase(), Buffer.from(responseEntry.tx_data, 'hex'), responseEntry.block_height);
    };
    return PaymentHistoryEntryShort;
}());
exports.default = PaymentHistoryEntryShort;
//# sourceMappingURL=payment-history-entry-short.js.map